import { defineStore } from 'pinia'
import { isToday } from 'date-fns'

interface Offer {
	default: boolean
	description: string
	has_order_item_count_limit: number
	id: number
	name: string
	order_item_count_limit: number | null
}
interface State {
	// last_updated: Date
	selfPaidProducts: Array<any> | null,
	insuranceProducts: Array<any> | null,
	offers: { mainOffer: Offer | null, otherOffers: Array<Offer> | null },
	examinationTypes: Array<any> | null
}

export const useCacheStore = defineStore('Cache', {
	state: (): State => ({
		selfPaidProducts: localStorage.getItem('selfpaid_products') ? JSON.parse(localStorage.getItem('selfpaid_products')) : null,
		insuranceProducts: localStorage.getItem('insurance_products') ? JSON.parse(localStorage.getItem('insurance_products')) : null,
		offers: localStorage.getItem('offers') ? JSON.parse(localStorage.getItem('offers')) : null,
		examinationTypes: localStorage.getItem('examinationTypes') ? JSON.parse(localStorage.getItem('examinationTypes')) : null
	}),

	actions: {
		setProducts(products: Array<any>, selfPaid: Boolean = false) {
			if (selfPaid) {
				this.selfPaidProducts = products
				localStorage.setItem('selfpaid_products', JSON.stringify(products))
			} else {
				this.insuranceProducts = products
				localStorage.setItem('insurance_products', JSON.stringify(products))
			}
		},

		setOffers(offers: { mainOffer: Offer | null, otherOffers: Array<Offer> | null }) {
			this.offers = offers
			localStorage.setItem('offers', JSON.stringify(offers))
		},

		setExaminationTypes(examinationTypes: Array<any>) {
			this.examinationTypes = examinationTypes
			localStorage.setItem('examinationTypes', JSON.stringify(examinationTypes))
		}
	},

	getters: {
		getInsuranceProducts: (state) => {
			return state.insuranceProducts
		},

		getSelfPaidProducts: (state) => {
			return state.selfPaidProducts
		},

		getOffers: (state) => {
			return state.offers
		},

		getExaminationTypes: (state) => {
			return state.examinationTypes
		},

		getDefaultOffer: (state) => {
			if (!state.offers || !state.offers.mainOffer)
				return null

			return state.offers.mainOffer
		}
	}
})
